import React from 'react'

const IconTrashTool = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M4 7h16' />
         <path d='M9 7V4h6v3' />
         <path d='M6 7l1 13h10l1-13' />
      </svg>
   )
}
export default IconTrashTool
